var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M19 4.5h-1v-2h-2v2H8v-2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20.5a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2m0 16H5v-11h14z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M7 11.5h5v5H7z"
})));
export { SvgDate as ReactComponent };
export default __webpack_public_path__ + "58b923c92be29cb1a02657e2233d484d.svg";